import { useEffect, useState } from "react";
const SCRIPT_ATTRIBUTE_KEYS = ["integrity", "crossOrigin", "id"];
const isScriptAttribute = (key) => {
    return SCRIPT_ATTRIBUTE_KEYS.includes(key);
};
export const useScript = ({ scriptSrc, attributes }) => {
    const [scriptStatus, setScriptStatus] = useState("unknown");
    useEffect(() => {
        const existingScript = [...document.scripts].find((script) => script.getAttribute("src") === scriptSrc);
        const updateStatus = (status) => {
            existingScript?.setAttribute("data-status", status);
            setScriptStatus(status);
        };
        const handleScriptLoad = () => {
            updateStatus("ready");
            cleanup();
        };
        const handleScriptError = () => {
            updateStatus("error");
            cleanup();
        };
        const cleanup = () => {
            existingScript?.removeEventListener("load", handleScriptLoad);
            existingScript?.removeEventListener("error", handleScriptError);
        };
        if (existingScript) {
            const scriptLoadStatus = existingScript.getAttribute("data-status");
            if (scriptLoadStatus === "ready" || scriptLoadStatus === "error") {
                setScriptStatus(scriptLoadStatus);
                return;
            }
            existingScript.addEventListener("load", handleScriptLoad);
            existingScript.addEventListener("error", handleScriptError);
            if (!scriptLoadStatus) {
                updateStatus("loading");
            }
            return;
        }
        const scriptTag = document.createElement("script");
        scriptTag.src = scriptSrc;
        scriptTag.async = true;
        scriptTag.setAttribute("data-status", "loading");
        updateStatus("loading");
        if (attributes) {
            Object.entries(attributes).forEach(([key, value]) => {
                if (isScriptAttribute(key)) {
                    scriptTag[key] = value;
                }
            });
        }
        scriptTag.addEventListener("load", handleScriptLoad);
        scriptTag.addEventListener("error", handleScriptError);
        document.body.appendChild(scriptTag);
        return () => {
            cleanup();
        };
    }, [scriptSrc, attributes]);
    return { scriptStatus };
};
//# sourceMappingURL=useScript.js.map